import React, { useState, useEffect } from "react";
import { Form, Table, Modal } from "react-bootstrap";
import { environment } from "../../../environment";
import axios from "axios";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../../Components/NavbarNew";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const PartnerList = () => {
  const [Partners, setPartners] = useState([]);
  const [partnerCount, setPartnerCount] = useState("");
  const [partnerdetails, setpartnerdetails] = useState({});
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };

  const [executivedetails, setexecutivedetails] = useState({});

  useEffect(() => {
    axios
      .get(environment.dap_url + "partnerApi/getAll")
      .then((res) => {
        console.log(res);

        const myDetails = JSON.parse(localStorage.getItem("userDetails"));

        const otherPartners = res.data.filter(item => item._id !== myDetails.data.id.id);
        setPartners(otherPartners.reverse());
        setPartnerCount(res.data.length);
      })
      .catch((err) => {
        MySwal.fire({
          title: "Error in retriving device.",
          icon: "warning",
        });
      });
  }, []);

  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  const getPartnerDetail = (_id) => {
    console.log(_id);
    axios
      .get(environment.dap_url + "partnerApi/ViewById/" + _id)
      .then((res) => {
        setpartnerdetails(res.data);
        handleShow();
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };
  console.log(partnerdetails);

  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "userFirstName",
      text: "Name",
      sort: true,
    },
    // {
    //   dataField: "userLastName",
    //   text: "LastName",
    //   sort: true,
    // },

    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "country",
      text: "Country",
      sort: true,
    },
    {
      dataField: "state",
      text: "State",
      sort: true,
    },
    {
      dataField: "city",
      text: "City",
      sort: true,
    },

    {
      dataField: "address",
      text: "Address",
      sort: true,
    },

    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <Button
              variant="primary"
              className="btn-sm"
              onClick={() => getPartnerDetail(dataField)}
            >
              View
            </Button>
          </div>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  return (
    <div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {partnerdetails.userFirstName + " " + partnerdetails.userLastName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th width="50%" scope="row">
                  Name
                </th>
                <td>
                  {partnerdetails.userFirstName +
                    " " +
                    partnerdetails.userLastName}
                </td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Email
                </th>
                <td>{partnerdetails.email}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Organization
                </th>
                <td>{partnerdetails.organization}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  DOB
                </th>
                <td>{partnerdetails.DOB}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Phone
                </th>
                <td>{partnerdetails.phone}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Country
                </th>
                <td>{partnerdetails.country}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  State
                </th>
                <td>{partnerdetails.state}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  City
                </th>
                <td>{partnerdetails.city}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Zip Code
                </th>
                <td>{partnerdetails.zip}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Address
                </th>
                <td>{partnerdetails.address}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Created_On
                </th>
                <td>{formatDate(partnerdetails.createdAt)}</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="container-fluid">
        <NavbarNew />
        <h4 className="card-title">PARTNERS</h4>
        <div className="row">
          <div className="col-12">
            <ToolkitProvider
              keyField="id"
              bootstrap4
              data={Partners}
              columns={columns}
              search
            >
              {(props) => (
                <div>
                  <div className="d-flex align-items-center">
                    <p className="mb-2 mr-2">Search in table:</p>
                    <SearchBar {...props.searchProps} />
                  </div>
                  <BootstrapTable
                    defaultSorted={defaultSorted}
                    pagination={paginationFactory()}
                    {...props.baseProps}
                    wrapperClasses="table-responsive"
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>

      {/* <h5 style={{ marginLeft: "5%" }}>
        Total Number of Entries: {partnerCount}
      </h5> */}
    </div>
  );
};

export default PartnerList;
